$(document).on('turbo:load', () => {
  
  $("#covid-receipt-file").on("change", (event) => { 
    var val = $('#covid-receipt-file').val();
    var spl = val.split('\\');
    var last = spl[spl.length - 1];
    var truncated = last.slice(0, 14);
    if (last.length > 14) {
      truncated = truncated + "...";
    }
    $('#selected-file-text').text(truncated);
    $('#covid-receipt-file-submit-btn').prop("disabled", false);
  });
});